<template>
  <!-- 导航开始 -->
  <div class='commonRecruimentTrace' :class="{scrollHide: isShowStoreBox}">
    <div class="mainBox" v-if="!isSearchLoading" v-for="app in memoData" :key="app.id">
      <div class="cards  mb-3">
        <div class="card-header">
          <i class="iconfont icon-clock"></i> {{app.timesStr}}
          <span @click="storeBoxFun(true,2, app.id)" class="btn btn-secondary btn-sm animated animated4 fadeIn">改</span>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6">录入者: {{app.adduid_name}}</div>
            <div class="col-6">面试官: {{app.interviewer_name}}</div>
          </div>
          <div class="description">
            <hr />{{app.content}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="memoData.length===0 && !isSearchLoading" class="emptyBox">
      <i class="iconfont icon-kong"></i>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
    <div v-show="isShowStoreBox" class="traceStoreBoxModel">
      <div class="traceStoreBox">
        <div class="xuanzeBox mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">面试时间</span>
            </div>
            <input type="text" ref="timesNode" onclick="WdatePicker({isShowClear:false,readOnly:true,dateFmt:'yyyy-MM-dd HH:mm'})" class="form-control" readonly="">
          </div>
        </div>
        <div class="mb-3">
          <multiselect v-model="userVal" track-by="name" label="name" placeholder="面试官" :options="userArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
        </div>
        <div class="textareaBox mb-3">
          <textarea placeholder="备注" class="form-control" aria-label="With textarea" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click.self="storeBoxFun(false)" class="btn btn-secondary btn-round">取消</button>
          <button v-if="type===2" type="button" @click.self="delBoxFun()" class="btn btn-danger btn-round">
            <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            删除
          </button>
          <button type="button" class="btn btn-success btn-round" @click="storeFun()">
            <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            {{type===1?'添加':'修改'}}
          </button>
        </div>
      </div>
    </div>
    <span v-if="!isShowStoreBox" @click="storeBoxFun(true,1)" class="tianjia btn btn-success btn-round">添加</span>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import datepicker from 'vue-date-picker';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'commonRecruimentTrace',
  props: ['token', 'parentInitResumeFun'],
  data() {
    return {
      isLoading: false,
      isDelLoading: false,
      isShowStoreBox: false,
      type: 1,
      str: '',
      // 备忘队列
      memoData: [],
      // 面试时间
      uptimeVal: '',
      // 备注
      contentVal: '',
      // 关系
      userVal: null,
      // 关系
      userArr: [
        { name: 'AAA', id: '1' },
        { name: 'BBB', id: '2' },
        { name: 'CCC', id: '3' },
      ],
      isSearchLoading: true,
    };
  },
  computed: {
  },
  methods: {
    // 显示表单框
    storeBoxFun(bool, type, str) {
      // 显示模态框
      if (bool) {
        this.type = type;
        if (type === 1) {
          // 添加
          this.str = '';
          this.$refs.timesNode.value = `${(new Date()).getFullYear()}-${(new Date()).getMonth() + 1}-${(new Date()).getDate()} ${(new Date()).getHours()}:${(new Date()).getMinutes()}`;
          this.contentVal = '';
          this.userVal = null;
        } else {
          // 修改
          this.str = str;
          const info = this.memoData.find(app => app.id === str);
          console.log(this.$refs.timesNode);
          this.$refs.timesNode.value = info.timesStr;
          this.contentVal = info.content;
          this.userVal = { id: info.interviewer, name: info.interviewer_name };
        }
      }
      // 模态框状态
      this.isShowStoreBox = bool;
    },
    // 提交表单
    storeFun() {
      // 处理中
      this.isLoading = true;
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 处理参数
      const parms = {
        times: this.$refs.timesNode.value,
        content: this.contentVal,
        interviewer: this.userVal.id,
      };
      if (this.type === 1) {
        parms.token = this.token;
      } else {
        parms.str = this.str;
      }
      // 提交数据
      resultCommons.apiResumeinterviewstore(this, parms).then((ob) => {
        if (ob.state === 200) {
          // 更新队列
          this.initResumeinterviewFun();
          // 模态框状态
          this.isShowStoreBox = false;
          // 根目录队列更新
          if (this.type === 1) {
            // 增加
            EventBus.$emit('rootIsSuccessInterviewFun', { type: 1, ob: [ob.data.token] });
          } else {
            // 修改
            EventBus.$emit('rootIsSuccessInterviewFun', { type: 3, ob: [this.str] });
          }
          // 提示框
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          // 提示框
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
        // 处理结束
        this.isLoading = false;
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
      });
    },
    // 删除
    delBoxFun() {
      // 处理中
      this.isDelLoading = true;
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交数据
      resultCommons.apiResumeinterviewdel(this, { str: this.str }).then((ob) => {
        if (ob.state === 200) {
          // 更新队列
          this.initResumeinterviewFun();
          // 模态框状态
          this.isShowStoreBox = false;
          // 根目录队列更新
          EventBus.$emit('rootIsSuccessInterviewFun', { type: 2, ob: [this.str] });
          // 提示框
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          // 提示框
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
        // 处理结束
        this.isDelLoading = false;
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
      });
    },
    // 初始化队列
    initResumeinterviewFun() {
      this.isSearchLoading = true;
      resultCommons.apiResumeinterview(this, { token: this.token }).then((ob) => {
        if (ob.state === 200) {
          this.memoData = ob.data.list;
        } else {
          // this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
        this.isSearchLoading = false;
      });
    },
    apiUserZaizhi() {
      resultCommons.apiUserZaizhi(this, {}).then((ob) => {
        if (ob.state === 200) {
          this.userArr = ob.data;
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
    datepicker,
    Multiselect,
  },
  created() {
    // 初始化列表
    this.initResumeinterviewFun();
    this.apiUserZaizhi();
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
  .commonRecruimentTrace{
    flex: 1;
    overflow-y: auto;
    background: #FFFFFF;
    padding: 15px;
    span.tianjia{
      position: absolute;
      display: inline-block;
      width: 90px;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      margin-bottom: 20px;
      text-align: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
    }
    div.traceStoreBoxModel{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0,0,0,0.1);
      backdrop-filter: blur(5px);
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      div.traceStoreBox{
        justify-content: center;
        align-items: center;
        box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
        padding: 30px 15px;
        background: #FFFFFF;
        div.xuanzeBox{
          display: flex;
          flex-direction: row;
          div.box{
            margin-right: 6px;
            flex: 1;
          }
          div.last{
            flex: 1;
            display: flex;
            align-items: center;
            margin: 0;
            div.form-group{
              margin: 0;
              .form-check{
                margin: 0;
              }
            }
          }
        }
        div.textareaBox{
          textarea{
            height: 90px;
            border-radius: 5px;
          }
        }
        div.anniuBox{
          text-align: right;
        }
      }
    }
    div.mainBox{
      margin-bottom: 10px;
      div.cards{
        border: 1px solid #D9DADB;
        border-radius: 10px;
        .card-header{
          span{
            float: right;
            font-family: 'gilroy-extrabold';
            display: none;
            font-size: 12px;
            border-radius: 4px;
            font-weight: 300;
            padding: 0;
            padding:1px 2px;
            padding-left: 3px;
          }
        }
        &:hover{
          .card-header{
            span{
              display: block;
            }
          }
        }
      }
    }
    div.emptyBox{
      text-align: center;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 70px;
        color: rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/recruiment/interview.vue